export default __webpack_public_path__ + "static/686-1cd5c67b10065c61f7ef285ea17392e2.gif";